import GenericModel from '@/shared/models/generic-model';
import i18n from '@/shared/plugins/vue-i18n';
import StringField from '@/shared/fields/string-field';
import IdField from '@/shared/fields/id-field';


const label = (name) => i18n.t(`DOCUMENT_SERIES_TYPE.FIELDS.${name.toUpperCase()}`);
const enumLabel = (name, value) => i18n.t(`DOCUMENT_SERIES_TYPE.ENUMS.${name.toUpperCase()}.${value.toUpperCase()}`);
const placeholder = (name) => i18n.t(`DOCUMENT_SERIES_TYPE.PLACEHOLDERS.${name.toUpperCase()}`);

const fields = {
    id: new IdField('id', 'Id'),
    name: new StringField('name', label('name'), { required: true }, {
        placeholder: placeholder('name'),
    }),
};

export class DocumentSeriesTypeModel extends GenericModel {
    static get fields() {
        return fields;
    }
}
